import { getApiUrl } from '../config/environment';

/**
 * Generate a Power BI connection URL for a tenant
 * @param token - The tenant's authentication token
 * @returns The complete PBI connection URL with authentication and date filtering
 */
export const generatePbiConnectionUrl = (token: string): string => {
  // Calculate start date (beginning of last year)
  const currentYear = new Date().getFullYear();
  const startDate = `${currentYear - 1}-01-01`;
  
  // Use the existing getApiUrl function with the correct endpoint
  const baseUrl = getApiUrl('expenses/download-data');
  
  // Construct the PBI connection URL
  const url = `${baseUrl}?token=${encodeURIComponent(token)}&format=csv&start_date=${startDate}`;
  
  return url;
};
